import React from "react";
import { useState } from "react";
import { useRecoilState } from "recoil";
import { toastState } from "../utils/atom";

const TextViewPopup_V4 = ({ row, onClose }) => {
    const [activeTab, setActiveTab] = useState("default"); // 'default' or 'sora'
    const [toast, setToast] = useRecoilState(toastState);

    const textCopy = () => {
        const textToCopy = JSON.stringify(
            {
                title: row.title,
                steps: row.steps.map((step, index) => ({
                    filename: `step_${index + 1}.jpg`,
                    title: step.title,
                    instruction: step.instruction,
                })),
            },
            null,
            2
        );

        navigator.clipboard
            .writeText(textToCopy)
            .then(() =>
                setToast({
                    isToast: true,
                    message: "레시피가 클립보드에 복사되었습니다.",
                })
            )
            .catch((err) => {
                console.error("텍스트 복사 실패:", err);
                setToast({
                    isToast: true,
                    message: "레시피 복사에 실패했습니다.",
                });
            });
    };

    if (!row) return null;

    return (
        <div className="modal bg-dark bg-opacity-50" style={{ display: "block" }}>
            <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
                <div className="modal-content">
                    <div className="modal-header px-3 py-2">
                        {/* 탭 버튼 */}
                        <ul className="nav nav-underline">
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === "default" ? "active" : ""}`}
                                    onClick={() => setActiveTab("default")}
                                >
                                    기본
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === "sora" ? "active" : ""}`}
                                    onClick={() => setActiveTab("sora")}
                                >
                                    이미지 생성 프롬프트
                                </button>
                            </li>
                        </ul>

                        <button className="btn-close" onClick={onClose}></button>
                    </div>
                    <div className="modal-body p-2">
                        {/* 기본 탭 내용 */}
                        {activeTab === "default" && (
                            <>
                                <div>
                                    <strong>제목:</strong> {row.title}
                                </div>
                                <div>
                                    <strong>소개:</strong> {row.soge}
                                </div>
                                <div>
                                    <strong>인분:</strong> {row.servings || ""}
                                </div>
                                <div>
                                    <strong>난이도:</strong> {row.difficulty || ""}
                                </div>
                                <div>
                                    <strong>조리시간:</strong> {row.cooking_time || ""}
                                </div>
                                <div>
                                    <strong>카테고리:</strong> {row.category || ""}
                                </div>
                                <div>
                                    <strong>태그:</strong> {row.tags || ""}
                                </div>
                                <div>
                                    <strong>작성자:</strong> {row.writer}
                                </div>
                                <div>
                                    <strong>출처:</strong> {row.source}
                                </div>

                                <hr />

                                <div>
                                    <strong>재료:</strong>
                                </div>
                                {Object.entries(row.ingredients).map(([key, ingredients], i) => (
                                    <div key={i} className="ms-3 mb-2">
                                        {ingredients.map((ing, idx) => (
                                            <div key={idx}>
                                                {ing.item}: {ing.capacity}
                                            </div>
                                        ))}
                                    </div>
                                ))}

                                <div className="d-flex justify-content-between align-items-center mb-2">
                                    <strong>이미지 매칭용 프롬프트(JSON):</strong>
                                    <button className="btn btn-outline-secondary btn-sm" onClick={textCopy}>
                                        복사하기
                                    </button>
                                </div>
                                <pre
                                    className="bg-body-tertiary p-2 rounded small"
                                    style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}
                                >
                                    {JSON.stringify(
                                        {
                                            title: row.title,
                                            steps: row.steps.map((step, index) => ({
                                                filename: `step_${index + 1}.jpg`,
                                                title: step.title,
                                                instruction: step.instruction,
                                            })),
                                        },
                                        null,
                                        2
                                    )}
                                </pre>
                            </>
                        )}

                        {activeTab === "sora" && (
                            <>
                                {/* Sora 프롬프트 탭 내용 */}
                                {row.steps.map((step, i) => {
                                    const textToCopy = `${step.title}
${step.instruction}
- 미니멀 일러스트레이션 인포그래픽 으로 그려주세요.
- 텍스트는 넣지 말아주세요.
- 배경은 파스텔 컬러로 해주세요.`;
                                    return (
                                        <div key={i} className="ms-3 mb-4">
                                            <div>
                                                <pre>
                                                    {i + 1}. {textToCopy}
                                                </pre>
                                            </div>
                                            <button
                                                className="btn btn-outline-secondary btn-sm w-100"
                                                onClick={() => {
                                                    navigator.clipboard
                                                        .writeText(textToCopy)
                                                        .then(() =>
                                                            setToast({
                                                                isToast: true,
                                                                message: "텍스트가 클립보드에 복사되었습니다.",
                                                            })
                                                        )
                                                        .catch((err) => {
                                                            console.error("텍스트 복사 실패:", err);
                                                            setToast({
                                                                isToast: true,
                                                                message: "텍스트 복사에 실패했습니다.",
                                                            });
                                                        });
                                                }}
                                            >
                                                복사
                                            </button>
                                        </div>
                                    );
                                })}
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TextViewPopup_V4;
